      <div class="col-md-10">
      <h3>Start Reference Checks - Registration for Organizations</h3>
      <form *ngIf="!success" (ngSubmit)="register()" #registerForm="ngForm" autocomplete="off" >      
            <div *ngIf="failure" class="alert alert-danger" i18n="@@errPleaseSendEmail">There was an error. Please send an email to register&#64;onreference.com with your company name, email and telephone contact and we will get back to you in max 2 working days.</div> 
            <div><a [routerLink]="['/ind-register']" class="btn btn-link" i18n="@@lnkNotAnOrgRegisterInd">Not an Organization ? Click here to Register as Individual / Vendor.</a></div>
            <div class="form-group">
                  <label for="firstname" i18n="@@lblFirstName"> First Name : </label>
                  <input type="text" class="form-control" id="firstname" name="firstname" autocomplete="off" [(ngModel)]="model.reffirstname" 
                  #firstname="ngModel" required autofocus>
                  <div [hidden]="firstname.valid || firstname.pristine" class="alert alert-danger" i18n="@@valEnterFirstName">
                        Please enter your First Name.
                  </div>
            </div>          
            <div class="form-group">
                  <label for="lastname" i18n="@@lblLastName"> Last Name : </label>
                  <input type="text" class="form-control" id="lastname" name="lastname" autocomplete="off" [(ngModel)]="model.reflastname" 
                  #lastname="ngModel" required>
                  <div [hidden]="lastname.valid || lastname.pristine" class="alert alert-danger" i18n="@@valEnterLastName">
                        Please enter your Last Name.
                  </div>
            </div>                      
            <div class="form-group">
                  <label for="company" i18n="@@lblOrgName"> Organization Name : </label>
                  <input type="text" class="form-control" id="company" name="company" autocomplete="off" [(ngModel)]="model.refcompany" 
                  #company="ngModel" required>
                  <div [hidden]="company.valid || company.pristine" class="alert alert-danger" i18n="@@valEnterOrgName">
                        Please enter your Organization name.
                  </div>
            </div>
            <div class="form-group">
                  <label for="phone" i18n="@@lblPhone"> Phone : </label>
                  <input type="text" class="form-control" id="phone" name="phone" autocomplete="off" [(ngModel)]="model.phone" 
                  #phone="ngModel" required>
                  <div [hidden]="phone.valid || phone.pristine" class="alert alert-danger" i18n="@@valEnterContactPhone">
                        Please enter your contact phone number at your Organization.
                  </div>
            </div>            
            <div class="form-group">
                  <label for="email" i18n="@@lblEmail"> Email : </label>
                  <input type="text" class="form-control" id="email" name="email" autocomplete="off" [(ngModel)]="model.refemail" 
                  #email="ngModel" required pattern="(?![A-Za-z0-9._%+-]+@gmail\.com|[A-Za-z0-9._%+-]+@hotmail\.com|[A-Za-z0-9._%+-]+@yahoo\.com|[A-Za-z0-9._%+-]+@yahoo\.ru|[A-Za-z0-9._%+-]+@yahoo\.in)([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,4}$)">
                  <div [hidden]="email.valid || email.pristine" class="alert alert-danger" i18n="@@valEnterEmailOrg">
                        Please enter the Organizational email id (Personal email is not valid).
                  </div>
            </div>
            <!--<div class="form-group">
                  <label for="password" i18n>Password : </label>
                  <input type="password" class="form-control" id="password" name="password" autocomplete="off" [(ngModel)]="model.password" 
                  #password="ngModel" required pattern=".{8,}">  
                  <div [hidden]="password.valid || password.pristine" class="alert alert-danger" i18n="@@valMin8PwdReqd">
                        Password is required (minimum length 8 characters).
                  </div>
            </div>
            <div class="form-group">
                  <label for="password2" i18n>Re-enter Password : </label>
                  <input type="password" class="form-control" id="password2" name="password2" autocomplete="off" [(ngModel)]="model.password2" 
                  #password2="ngModel" required>  
                  <div [hidden]="(password2.valid && (password.value === password2.value)) || password2.pristine" class="alert alert-danger" i18n="@@valReenterPwd">
                        Re enter Password does not match the Password entered above.
                  </div>
            </div> -->
            <re-captcha
                  [(ngModel)]="formModel.captcha"
                  name="captcha"
                  required
                  siteKey="6LfQfCkUAAAAAJgZfY8xY3JdG71PSrxNazVm-2Ol"
                  #captchaControl="ngModel"
            ></re-captcha>
            <div class="form-group">
                  <!--<button type="submit" class="btn btn-primary" [disabled]="!registerForm.valid || loading || failure" i18n="@@btnSubmit">Submit</button>                  -->
                  <button type="submit" class="btn btn-primary" [disabled]="!registerForm.valid || loading || failure " ><span i18n="@@btnSubmit"> Submit </span> <i *ngIf="loading" class="fa fa-spinner fa-pulse"></i></button>                  
                  <a *ngIf="!loading" [routerLink]="['/org-login']" class="btn btn-link" i18n="@@btnCancel">Cancel</a>
            </div>
      </form>
      <div *ngIf="success" i18n="@@msgThanksSubmittingReg">Thank you for submitting your registration to Onreference. We will get back to you at the contact information provided in max 2 working days. Thanks.</div>
      <div *ngIf="success"><a [routerLink]="['/org-login']" class="btn btn-link" i18n="@@msgGoToLogin">Go to Sign In page</a></div>

      </div>